import React from 'react';
import Banner from './banner';
import ChooseUs from './choose';
import './css/home.css';
import RecentWork from './recentWork';
import Testimonials from './testimonials';
import Township from './township';


const Home = () => {

    return (
        <div>
            <Banner />
            <ChooseUs />
            <Township />
            <RecentWork />
            <Testimonials />

            <div className='gallery'>
                <div></div>
            </div>

        </div>
    )
}

export default Home;
